import { useFormik } from "formik";
import axiosInstance from "../../../axiosInterceptor";
import { currencyschema } from "../../../Schema/Schema";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Upload from "../../../Components/upload";
import { SwitchToggle } from "../../../helper/ImageFormat";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const AddCurrency = () => {
 const location = useLocation();
  const navigator = useNavigate();
 const editData = location.state;
 const editingId = editData?.id;

 const [loading, setLoading] = useState(false);
 const initialValues = {
  code: "",
  symbol: "",
  rate: "",
  flag: "",
  isActive: true,
 };

 const {
  errors,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  touched,
 } = useFormik({
  initialValues,
  validationSchema: currencyschema,
  onSubmit: async (values, { resetForm }) => {
   setLoading(true);
   try {
    const response = editingId
     ? await axiosInstance.put(`/currency/${editingId}`, values)
     : await axiosInstance.post("/currency", values);

    if (response.status === 200) {
        navigator("/currency");
     toast.success(response?.data?.message);
    }
   } catch (err) {
    toast.error(err?.response?.data?.message);
   } finally {
    setLoading(false);
   }
  },
 });

 useEffect(() => {
  if (editingId) {
   setFieldValue("code", editData?.code || "");
   setFieldValue("symbol", editData?.symbol || "");
   setFieldValue("rate", editData?.rate || "");
   setFieldValue("flag", editData?.flag || "");
   setFieldValue("isActive", editData?.isActive ?? true);
  }
 }, [editingId, setFieldValue]);


 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="page-title">{editData?.id ? "Update" : "Add"} Currency</h3>
   </div>

   <div className="row grid-margin stretch-card">
    <div className="col-md-12">
     <div className="card">
      <div className="card-body">
       <form onSubmit={handleSubmit}>
        <div className="row g-3">
         <div className="col-lg-6 col-md-12">
          <label className="col-form-label" htmlFor="code">
           Currency Code
          </label>
          <input
           type="text"
           name="code"
           id="code"
           className="form-control form-control-sm border border-dark"
           placeholder="Enter code (e.g. USD)"
           value={values.code}
           onChange={(e) => {
            const upperCaseValue = e.target.value.toUpperCase();
            setFieldValue("code", upperCaseValue);
           }}
           onBlur={handleBlur}
          />
          {touched.code && errors.code && (
           <div className="text-danger">{errors.code}</div>
          )}
         </div>

         <div className="col-lg-6 col-md-12">
          <label className="col-form-label" htmlFor="symbol">
           Symbol
          </label>
          <input
           type="text"
           name="symbol"
           id="symbol"
           placeholder="Enter symbol (e.g. $)"
           className="form-control form-control-sm border border-dark"
           value={values.symbol}
           onChange={handleChange}
           onBlur={handleBlur}
          />
          {touched.symbol && errors.symbol && (
           <div className="text-danger">{errors.symbol}</div>
          )}
         </div>

         <div className="col-lg-6 col-md-12">
          <label className="col-form-label" htmlFor="rate">
           Conversion Rate
          </label>
          <input
           type="number"
           name="rate"
           id="rate"
           value={values.rate}
           placeholder="Enter conversion rate"
           className="form-control form-control-sm border border-dark"
           onChange={handleChange}
           onBlur={handleBlur}
          />
          {touched.rate && errors.rate && (
           <div className="text-danger">{errors.rate}</div>
          )}
         </div>

         <div className="col-lg-6 col-md-12 mt-2">
          <label className="form-label fw-bold"> Upload Flag</label>
          <Upload
           label="currency-flag"
           initialImage={values.flag}
           onChange={(imgUrl) => setFieldValue("flag", imgUrl)}
           apiUrl={"uploads?label=currency"}
          />
         </div>

         <div className="col-md-12 mt-4">
          <SwitchToggle
           checked={values.isActive}
           onChange={(val) => setFieldValue("isActive", val)}
           activeLabel="Active"
           inactiveLabel="Inactive"
          />
         </div>

         <div
          className="col-12 mt-4 d-flex justify-content-center "
          style={{ gap: "15px" }}
         >
          <button type="submit" className="btn btn-primary" disabled={loading}>
           {loading ? "Loading..." : editData?.id ? "Update" : "Add"}
          </button>
          <Link to="/currency">
           <button type="button" className="btn btn-danger">
            Cancel
           </button>
          </Link>
         </div>
        </div>
       </form>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AddCurrency